// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2gAZW","header-item":"Header_header-item__2O4jB"};